/**
 * Shared economy helpers. Currently: gatherer-capacity accounting for "worked
 * buildings" like fields, which only allow a fixed number of simultaneous
 * gatherers (a field staffs at most 2 farmers). Lives outside any one system so
 * commands (assignment), the farm system (enforcement), and the bot all agree.
 */
import type { World } from "./world";
import type { Eid } from "./types";
import { canGatherNode } from "./naval";

/** Number of gatherers currently assigned to (heading to / working) a node. */
export function countGatherers(world: World, node: Eid, except?: Eid): number {
  let n = 0;
  for (const [eid, g] of world.gatherer) {
    if (eid === except) continue;
    if (g.node === node) n++;
  }
  return n;
}

/** A node's simultaneous-gatherer cap, or Infinity if uncapped (normal nodes). */
export function gatherCapOf(world: World, node: Eid): number {
  return world.resource.get(node)?.cap ?? Infinity;
}

/** Whether `eid` may join `node` as a gatherer: it must be able to REACH the node
 *  (same movement domain — no land worker fishing a water node) AND not exceed the
 *  node's simultaneous-gatherer cap. */
export function canGatherFrom(world: World, node: Eid, eid: Eid): boolean {
  if (!canGatherNode(world, eid, node)) return false; // wrong domain (e.g. worker → fish)
  return countGatherers(world, node, eid) < gatherCapOf(world, node);
}
